<template>
  <div class="group-info x-margin x-border-50">
    <my-head-title :title="$t('HT.voltageInfo.title')"></my-head-title>
    <div class="x-padding">
      <div class="button-padding">
        <ux-button type="primary">{{ $t('HT.voltageInfo.text') }}</ux-button>
      </div>
      <div>
        <ux-table
          ref="table"
          :showPage="false"
          :data="appList"
          :columns="columns"
          layout="total, sizes, prev, pager, next"
          :emptyText="$t('HT.nodata')"
        ></ux-table>
        <ux-button class="loading-more" type="primary">{{ $t('HT.loadMore') }}</ux-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appList: [],
      columns: [
        {
          label: 'IMEI',
          prop: 'imei',
          tooltip: true
        },
        {
          label: this.$t('HT.voltageInfo.voltage'),
          prop: 'voltage',
          tooltip: true
        },
        {
          label: this.$t('HT.voltageInfo.time'),
          prop: 'time',
          tooltip: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.button-padding {
  padding-bottom: 20px;
}
.loading-more {
  margin-top: 20px;
}
</style>
